<template>
  <div class="w-100 confirmation-page auto">
    <!-- START Content Wrapper -->
    <div class="row mx-0">
      <div class="col">
        <!-- CONTENT HEADER-->
        <div class="row">
          <div class="col-12 mb-3 text-center text-white product-section-heading" :class="{'error' : isBindError}">
            <div class="row no-gutters">
              <div class="col-2 policy-type">
                <span class="fas fa-car"></span> Auto
              </div>
              <div class="col-10 pr-2 text-left">
                <h1 class="title-banner m-0">{{ pageTitle }}</h1>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="isBindError">
          <div class="col-12 carrier-logo-property text-center my-3 min-height align-items-center justify-content-center d-flex">
            <img :src="logoPathSvg" alt="logo" width="180.763px" height="auto" />
          </div>
          <div class="col-12 p-0">
            <div class="shadow-sm rounded">
              <div class="py-2 pl-3 mb-2 text-white  product-section-heading rounded-top" role="heading"
                aria-level="3">
                Next steps
              </div>
              <div class="row mx-0 pt-8 px-3 pb-3 next-step-row">
                {{ pageData.Error.Message }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
        <div class="my-3" v-for="(group, i) in dataTree" :key='i' v-if="group && !isBindError">
          <form-sections :group="group" :i='i' :pageData="pageData"></form-sections>
        </div>
        </div>
      </div>
    </div>
    <!-- END Content Wrapper -->
    <hr v-if="footerNote()" />
    <!-- bottom Instruction SECTION -->
    <div v-if="footerNote()" class="d-flex justify-content-center mx-auto mt-3">
      <div class="alert alert-primary my-0 py-2 w-50" role="note">
        <div class="row no-gutters">
          <div class="d-inline-block pr-2 my-auto">
            <img width="25px" height="25px" src="../../../assets/info-circle-blue.svg" alt="info">
          </div>
          <div class="col d-inline-block my-auto smaller-font-content">{{ footerNote() }}</div>
        </div>
      </div>
    </div>
    <!-- bottom Instruction SECTION END -->
  </div>
</template>

<script>
// TODO: Remove eslint
/* eslint-disable */
import FormSections from '../../presentational/FormSections';
import fetchData from '../../../services/fetchData';
import common from '../../../services/common';
import { pageMixin } from '../../../mixins/pageMixin';

export default {
  mixins: [pageMixin],
  data() {
    return {
      pageData: {},
      pageTitle: '',
      dataTree: [],
      isBindError: false,
      logoPathSvg: '',
    };
  },
  components: {
    FormSections,
  },
  methods: {
    // TODO: Remove after development is complete.
    fallbackData() {
      // TODO: Remove mock data.
      const config = {};

      return {
        page_name: 'progConfirmation',
        tab_buttons: [
          {
            name: 'NamedInsured',
            label: 'Named Insured',
            status: 'InactiveComplete',
            type: 'Tab',
            on_click: '/navs/NamedInsuredTab',
            action: 'POST',
            section: 'RC1',
          },
          {
            name: 'Vehicles',
            label: 'Vehicle(s)',
            status: 'InactiveComplete',
            type: 'Tab',
            on_click: '/navs/VehiclesTab',
            action: 'POST',
            section: 'RC1',
          },
          {
            name: 'Drivers',
            label: 'Driver(s)',
            status: 'InactiveComplete',
            type: 'Tab',
            on_click: '/navs/DriversTab',
            action: 'POST',
            section: 'RC1',
          },
          {
            name: 'PriorInsurance',
            label: 'Prior Insurance',
            status: 'InactiveComplete',
            type: 'Tab',
            on_click: '/navs/PriorInsuranceTab',
            action: 'POST',
            section: 'RC1',
          },
          {
            name: 'NewCoverages',
            label: 'New Coverages',
            status: 'InactiveComplete',
            type: 'Tab',
            on_click: '/navs/NewCoveragesTab',
            action: 'POST',
            section: 'RC1',
          },
          {
            name: 'CarrierMatches',
            label: 'Carrier Matches',
            status: 'Disabled',
            type: 'Tab',
            on_click: '/navs/CarrierMatches',
            action: 'POST',
            section: 'RC1',
          },
          {
            name: 'ContactDetails',
            label: 'Contact Details',
            status: 'InactiveComplete',
            type: 'Tab',
            on_click: '/navs/ContactDetailsTab',
            action: 'POST',
            section: 'RC2',
          },
          {
            name: 'DriverVehicleDetails',
            label: 'Driver/Vehicle Details',
            status: 'InactiveComplete',
            type: 'Tab',
            on_click: '/navs/DriverVehicleDetailsTab',
            action: 'POST',
            section: 'RC2',
          },
          {
            name: 'PolicyDetails',
            label: 'Policy Details',
            status: 'InactiveComplete',
            type: 'Tab',
            on_click: '/navs/PolicyDetailsTab',
            action: 'POST',
            section: 'RC2',
          },
          {
            name: 'Checkout',
            label: 'Checkout',
            status: 'InactiveComplete',
            type: 'Tab',
            on_click: '/navs/CheckoutTab',
            action: 'POST',
            section: 'RC2',
          },
          {
            name: 'Confirmation',
            label: 'Confirmation',
            status: 'ActiveComplete',
            type: 'Tab',
            on_click: '/navs/ConfirmationTab',
            action: 'POST',
            section: 'RC2',
          },
        ],
        continue_buttons: [],
        polk_buttons: [],
        new_buttons: [],
        section_buttons: [],
        add_buttons: [],
        fields: [
          {
            field_name: 'QTE_CAR_PolicyNumber',
            field_type: 'label',
            label: 'Policy Number',
            field_value: '800903720',
            group_id: 4,
            index: null,
            sub_index: null,
            display_order: 1,
            section_display_order: 0,
            help_text: '',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 255,
            section: '',
            section_type: '',
            sub_section: '',
            sub_section_type: '',
            sub_index_section: '',
            sub_index_section_type: '',
            rules: [],
            values: [],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_BindCoverageStartDate',
            field_type: 'label',
            label: 'Policy Start Date',
            field_value: '20190228',
            group_id: 1,
            index: null,
            sub_index: null,
            display_order: 2,
            section_display_order: 0,
            help_text: '',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 8,
            section: '',
            section_type: '',
            sub_section: '',
            sub_section_type: '',
            sub_index_section: '',
            sub_index_section_type: '',
            rules: [],
            values: [],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_CAR_Term',
            field_type: 'label',
            label: 'Policy Term',
            field_value: '12Month',
            group_id: 4,
            index: null,
            sub_index: null,
            display_order: 3,
            section_display_order: 0,
            help_text: '',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 255,
            section: '',
            section_type: '',
            sub_section: '',
            sub_section_type: '',
            sub_index_section: '',
            sub_index_section_type: '',
            rules: [],
            values: [],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_ProgBQtePaymentPlan',
            field_type: 'label',
            label: 'Which payment plan would you like?',
            field_value: '12',
            group_id: 1,
            index: null,
            sub_index: null,
            display_order: 4,
            section_display_order: 0,
            help_text: '',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 100,
            section: '',
            section_type: '',
            sub_section: '',
            sub_section_type: '',
            sub_index_section: '',
            sub_index_section_type: '',
            rules: [],
            values: [
              {
                display_value: '6 months',
                internal_value: '6',
                visible: true,
                display_order: 0,
              },
              {
                display_value: '12 months',
                internal_value: '12',
                visible: true,
                display_order: 1,
              },
            ],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_CAR_Premium',
            field_type: 'label',
            label: 'Premium Total',
            field_value: '3353.00',
            group_id: 4,
            index: null,
            sub_index: null,
            display_order: 5,
            section_display_order: 0,
            help_text: '',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 20,
            section: '',
            section_type: '',
            sub_section: '',
            sub_section_type: '',
            sub_index_section: '',
            sub_index_section_type: '',
            rules: [],
            values: [],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_DownpaymentAmount',
            field_type: 'label',
            label: 'Due Today',
            field_value: '304.79',
            group_id: 1,
            index: null,
            sub_index: null,
            display_order: 6,
            section_display_order: 0,
            help_text: '',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 20,
            section: '',
            section_type: '',
            sub_section: 'Today\'s Payment Information',
            sub_section_type: '',
            sub_index_section: '',
            sub_index_section_type: '',
            rules: [],
            values: [],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_DownpaymentMethod',
            field_type: 'label',
            label: 'Payment Method',
            field_value: 'CC',
            group_id: 1,
            index: null,
            sub_index: null,
            display_order: 7,
            section_display_order: 0,
            help_text: '',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 100,
            section: '',
            section_type: '',
            sub_section: 'Today\'s Payment Information',
            sub_section_type: '',
            sub_index_section: '',
            sub_index_section_type: '',
            rules: [],
            values: [
              {
                display_value: 'Personal Checking Account',
                internal_value: 'EFT',
                visible: true,
                display_order: 0,
              },
              {
                display_value: 'Credit Card',
                internal_value: 'CC',
                visible: true,
                display_order: 1,
              },
            ],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_InstallmentAmount',
            field_type: 'label',
            label: 'Monthly Payment',
            field_value: '305.83',
            group_id: 1,
            index: null,
            sub_index: null,
            display_order: 8,
            section_display_order: 0,
            help_text: '',
            sub_text: '',
            placeholder: '',
            visible: false,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 8,
            section: '',
            section_type: '',
            sub_section: 'Monthly Payment Information',
            sub_section_type: '',
            sub_index_section: '',
            sub_index_section_type: '',
            rules: [],
            values: [],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_InstallmentPaymentMethod',
            field_type: 'label',
            label: 'Payment Method',
            field_value: 'EFT',
            group_id: 1,
            index: null,
            sub_index: null,
            display_order: 9,
            section_display_order: 0,
            help_text: '',
            sub_text: '',
            placeholder: '',
            visible: false,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 255,
            section: '',
            section_type: '',
            sub_section: 'Monthly Payment Information',
            sub_section_type: '',
            sub_index_section: '',
            sub_index_section_type: '',
            rules: [],
            values: [
              {
                display_value: 'Personal Checking Account',
                internal_value: 'EFT',
                visible: true,
                display_order: 0,
              },
              {
                display_value: 'Credit Card',
                internal_value: 'CC',
                visible: true,
                display_order: 1,
              },
            ],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_CovMiniTort',
            field_type: 'label',
            label: 'Limited Property Damage Liability (Mini Tort)',
            field_value: 'Y',
            group_id: 1,
            index: null,
            sub_index: null,
            display_order: 32,
            section_display_order: 0,
            help_text: '<p>This coverage that provides up to $1000 protection against lawsuits. Under Mini Tort, you may be sued and have to pay up to $1000 for an accident where you are 50% or more at fault and where damages to the other driver\'s car are not completely covered by their insurance.</p>\r\n<p>You may sue the other driver if they are 50% or more at fault for damages to your car that are not completely covered by your insurance. In either instance the amount a driver will have to pay will be based on amount of fault and shall not exceed $1000.</p>',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 100,
            section: 'Coverage Summary',
            section_type: '',
            sub_section: 'Liability Coverages',
            sub_section_type: '',
            sub_index_section: '',
            sub_index_section_type: '',
            rules: [],
            values: [
              {
                display_value: 'Yes',
                internal_value: 'Y',
                visible: true,
                display_order: 0,
              },
              {
                display_value: 'No',
                internal_value: 'N',
                visible: true,
                display_order: 1,
              },
            ],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_CovPPIResidualPD',
            field_type: 'label',
            label: 'Property Protection Insurance',
            field_value: '1000000',
            group_id: 1,
            index: null,
            sub_index: null,
            display_order: 33,
            section_display_order: 0,
            help_text: '<p>This coverage will pay up to $1 million for damages caused to other people\'s property in Michigan, \r\nsuch as buildings and fences, regardless of fault.  It will also pay for damage your car does to another person\'s properly parked vehicle.  \r\nIt does not pay for any other damage to cars.  Damage to your own property is not covered.<br/>If the incident occurs outside Michigan, Residual Property Damage Liability Insurance covers your legal liability for property damage.<br/>\r\nPlease Note:  This coverage explanation is intended for informational purposes only.  All terms and coverages are defined solely by your policy.</p>',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 10,
            section: 'Coverage Summary',
            section_type: '',
            sub_section: 'Liability Coverages',
            sub_section_type: '',
            sub_index_section: '',
            sub_index_section_type: '',
            rules: [],
            values: [],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_CovBipd',
            field_type: 'label',
            label: 'Bodily Injury & Property Damage Coverage',
            field_value: '50-100-50',
            group_id: 1,
            index: null,
            sub_index: null,
            display_order: 41,
            section_display_order: 0,
            help_text: '<strong>Bodily injury limit:</strong> This is the maximum amount your insurance policy will pay when an insured person becomes legally liable for bodily injury or death caused by an insured person in an auto accident.\r\n<br><br>\r\n<strong>Property damage limit:</strong> This is the maximum amount your insurance policy will pay when an insured person becomes legally liable for damage an insured person causes in an auto accident to the property of other people (e.g. light poles, fences, another vehicle, etc.).\r\n<br><br>\r\n<strong>Some carriers might not cover:</strong><br>\r\n<ul>\r\n<li>Bodily injury or property damage arising out of the use of your vehicle while transporting people or property for a fee.</li>\r\n<li>Injury or damage caused by an intentional act.</li>\r\n<li>Injury or damage as a result of operating a vehicle owned by a person covered by your policy, where the<br> vehicle is not listed on your policy.</li>\r\n<li>Injury or death of you or a family member.</li>\r\n<li>Property owned by, rented by or in the control of an insured person.</li>',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 100,
            section: 'Coverage Summary',
            section_type: '',
            sub_section: 'Liability Coverages',
            sub_section_type: '',
            sub_index_section: '',
            sub_index_section_type: '',
            rules: [],
            values: [
              {
                display_value: '$20,000 person/$40,000 accident/$10,000 property',
                internal_value: '20-40-10',
                visible: true,
                display_order: 0,
              },
              {
                display_value: '$50,000 person/$100,000 accident/$50,000 property',
                internal_value: '50-100-50',
                visible: true,
                display_order: 1,
              },
              {
                display_value: '$100,000 person/$300,000 accident/$50,000 property',
                internal_value: '100-300-50',
                visible: true,
                display_order: 2,
              },
              {
                display_value: '$100,000 person/$300,000 accident/$100,000 property',
                internal_value: '100-300-100',
                visible: true,
                display_order: 3,
              },
              {
                display_value: '$250,000 person/$500,000 accident/$100,000 property',
                internal_value: '250-500-100',
                visible: true,
                display_order: 4,
              },
            ],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_CovPIPIncomeLoss',
            field_type: 'label',
            label: 'Personal Injury Protection-Lost Wages/Work Loss',
            field_value: 'PIPWLPrim',
            group_id: 1,
            index: null,
            sub_index: null,
            display_order: 73,
            section_display_order: 0,
            help_text: '<p>This coverage will pay up to 85% of your lost income for up to three years from the date of the accident. This benefit is subject to a maximum amount and the terms of the carrier policy.</p>\r\n<p>As with no-fault medical benefits, work loss benefits can be purchased on a coordinated or excess basis. If you have disability coverage that will pay work loss benefits on a primary basis, you can choose to make that coverage primary and save money on your auto insurance. Payment under this option may be subject to a deductible. Be sure to read your policy or consult your benefit plan administrator before choosing coordinated coverage.</p>\r\n<p>A person who is 60 years of age or older and would suffer no loss of income if injured in a motor vehicle accident may waive coverage for work loss benefits and receive a slightly reduced premium.</p>',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 100,
            section: 'Coverage Summary',
            section_type: '',
            sub_section: 'Liability Coverages',
            sub_section_type: '',
            sub_index_section: '',
            sub_index_section_type: '',
            rules: [],
            values: [
              {
                display_value: 'Primary',
                internal_value: 'PIPWLPrim',
                visible: true,
                display_order: 0,
              },
            ],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_CovPIPMedicalExpenses',
            field_type: 'label',
            label: 'Personal Injury Protection-Medical Payments/ Hospital Benefits/Funeral Expenses',
            field_value: 'PIPMedPrim',
            group_id: 1,
            index: null,
            sub_index: null,
            display_order: 74,
            section_display_order: 0,
            help_text: '<p>MI is a no-fault state. There is a restriction on your rights to sue for damages. The coverage however is very broad. Please review statutes for specifics.</p>  <p>PIP covers injuries to covered persons resulting from a motor vehicle accident, regardless of who is at fault in the accident. PIP covers you, your spouse, relatives who live with you and, in some instances, other people occupying your vehicle. This pays for all reasonably necessary products, services, or accommodations necessary for an injured person\'s care, recovery, or rehabilitation.</p>  <p>If you have health insurance that will pay medical expenses from a motor vehicle accident on a primary basis, you can save money on your auto insurance premium by purchasing what is known as coordinated or excess coverage. Under this option, payment for medical expenses is made to the extent available under your health plan before expenses are submitted to the auto insurer. Payment under this option may be subject to a deductible. Some health plans exclude payment for expenses resulting from auto accidents.</p>',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 100,
            section: 'Coverage Summary',
            section_type: '',
            sub_section: 'Liability Coverages',
            sub_section_type: '',
            sub_index_section: '',
            sub_index_section_type: '',
            rules: [],
            values: [
              {
                display_value: 'Primary',
                internal_value: 'PIPMedPrim',
                visible: true,
                display_order: 0,
              },
            ],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_CovUmuim',
            field_type: 'label',
            label: 'Uninsured/Underinsured Motorists Bodily Injury',
            field_value: 'None',
            group_id: 1,
            index: null,
            sub_index: null,
            display_order: 112,
            section_display_order: 0,
            help_text: '<strong>Uninsured Motorist Bodily Injury limit:</strong>\r\nThis is the maximum amount your insurance policy will pay for bodily injury or death to you, covered family members, and/or the occupants of your insured vehicle caused by a motorist who is legally liable but does not have insurance.<br><br>\r\n<strong>Underinsured Motorist Bodily Injury limit:</strong>\r\nThis is the maximum amount your insurance policy will pay in excess of the amount of Liability Bodily Injury insurance carried by an at fault motorist for bodily injury or death to you, covered family members, and/or the occupants of your insured vehicle caused by the at-fault motorist, who is legally liable but does not have enough insurance.\r\n<br><br>\r\n<strong>Some carriers might not cover:</strong>\r\n<ul>\r\n<li>When your vehicle is being used to transport people or property for a fee.</li>\r\n<li>When a covered vehicle is used without the permission of you or a relative.</li>\r\n<li>Use of a non-owned vehicle by you without permission of the owner.</li>\r\n</ul>',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 100,
            section: 'Coverage Summary',
            section_type: '',
            sub_section: 'Liability Coverages',
            sub_section_type: '',
            sub_index_section: '',
            sub_index_section_type: '',
            rules: [],
            values: [
              {
                display_value: 'No Coverage',
                internal_value: 'None',
                visible: true,
                display_order: 0,
              },
              {
                display_value: '$20,000 person/$40,000 accident',
                internal_value: '20-40',
                visible: true,
                display_order: 1,
              },
              {
                display_value: '$50,000 person/$100,000 accident',
                internal_value: '50-100',
                visible: true,
                display_order: 2,
              },
            ],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_VEH_0_Comprehensive',
            field_type: 'label',
            label: 'Comprehensive Deductible',
            field_value: 'CompDed250',
            group_id: 3,
            index: 0,
            sub_index: null,
            display_order: 141,
            section_display_order: 0,
            help_text: 'Covers vehicle damage, up to vehicle cash value, for non-accident and non-collision claims such as vandalism, damage due to an act of nature, animal collisions and vehicle theft.',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 100,
            section: 'Coverage Summary',
            section_type: '',
            sub_section: 'Vehicle Coverages',
            sub_section_type: '',
            sub_index_section: '2006 NISSAN ALTIMA S',
            sub_index_section_type: '',
            rules: [],
            values: [
              {
                display_value: 'No Coverage (Liability Only)',
                internal_value: 'CompNoCoverage',
                visible: true,
                display_order: 0,
              },
              {
                display_value: '$250 Deductible',
                internal_value: 'CompDed250',
                visible: true,
                display_order: 1,
              },
              {
                display_value: '$500 Deductible',
                internal_value: 'CompDed500',
                visible: true,
                display_order: 2,
              },
              {
                display_value: '$1,000 Deductible',
                internal_value: 'CompDed1000',
                visible: true,
                display_order: 3,
              },
            ],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_VEH_0_Collision',
            field_type: 'label',
            label: 'Collision Deductible',
            field_value: 'CollDedStd250',
            group_id: 3,
            index: 0,
            sub_index: null,
            display_order: 142,
            section_display_order: 0,
            help_text: 'Coverage applies to damage for policy vehicles, up to vehicle cash value, as a result of when the vehicle is moving and overturns or strikes another object.',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 100,
            section: 'Coverage Summary',
            section_type: '',
            sub_section: 'Vehicle Coverages',
            sub_section_type: '',
            sub_index_section: '2006 NISSAN ALTIMA S',
            sub_index_section_type: '',
            rules: [],
            values: [
              {
                display_value: 'No Coverage (Liability Only)',
                internal_value: 'CollNoCoverage',
                visible: true,
                display_order: 0,
              },
              {
                display_value: '$250 Deductible - Standard',
                internal_value: 'CollDedStd250',
                visible: true,
                display_order: 1,
              },
              {
                display_value: '$500 Deductible - Standard',
                internal_value: 'CollDedStd500',
                visible: true,
                display_order: 2,
              },
              {
                display_value: '$1,000 Deductible - Standard',
                internal_value: 'CollDedStd1000',
                visible: true,
                display_order: 3,
              },
              {
                display_value: '$250 Deductible - Broad',
                internal_value: 'CollDedBrd250',
                visible: true,
                display_order: 4,
              },
              {
                display_value: '$500 Deductible - Broad',
                internal_value: 'CollDedBrd500',
                visible: true,
                display_order: 5,
              },
              {
                display_value: '$1,000 Deductible - Broad',
                internal_value: 'CollDedBrd1000',
                visible: true,
                display_order: 6,
              },
            ],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_VEH_0_Rental',
            field_type: 'label',
            label: 'Rental Reimbursement',
            field_value: 'Y',
            group_id: 3,
            index: 0,
            sub_index: null,
            display_order: 143,
            section_display_order: 0,
            help_text: 'Coverage covers rental expenses, up to the selected limits, for when policy vehicles are disabled or in for repairs due to a loss covered by collision or comprehensive coverage.',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 100,
            section: 'Coverage Summary',
            section_type: '',
            sub_section: 'Vehicle Coverages',
            sub_section_type: '',
            sub_index_section: '2006 NISSAN ALTIMA S',
            sub_index_section_type: '',
            rules: [],
            values: [
              {
                display_value: 'Yes',
                internal_value: 'Y',
                visible: true,
                display_order: 0,
              },
              {
                display_value: 'No',
                internal_value: 'N',
                visible: true,
                display_order: 1,
              },
            ],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_VEH_0_Towing',
            field_type: 'label',
            label: 'Towing and Labor',
            field_value: 'Y',
            group_id: 3,
            index: 0,
            sub_index: null,
            display_order: 144,
            section_display_order: 0,
            help_text: 'Coverage reimburses towing and labor costs, up to the selected limit, for disabled policy vehicle(s), regardless of cause. Some carriers refer to “towing” as “roadside assistance”. Few carriers offer roadside assistance similar to AAA, where they actually come and get the customer.',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 100,
            section: 'Coverage Summary',
            section_type: '',
            sub_section: 'Vehicle Coverages',
            sub_section_type: '',
            sub_index_section: '2006 NISSAN ALTIMA S',
            sub_index_section_type: '',
            rules: [],
            values: [
              {
                display_value: 'Yes',
                internal_value: 'Y',
                visible: true,
                display_order: 0,
              },
              {
                display_value: 'No',
                internal_value: 'N',
                visible: true,
                display_order: 1,
              },
            ],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_VEH_0_CustomizationCoverage',
            field_type: 'label',
            label: 'Customized Equipment Coverage',
            field_value: 'None',
            group_id: 3,
            index: 0,
            sub_index: null,
            display_order: 145,
            section_display_order: 0,
            help_text: '',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 100,
            section: 'Coverage Summary',
            section_type: '',
            sub_section: 'Vehicle Coverages',
            sub_section_type: '',
            sub_index_section: '2006 NISSAN ALTIMA S',
            sub_index_section_type: '',
            rules: [],
            values: [
              {
                display_value: 'No Coverage',
                internal_value: 'None',
                visible: true,
                display_order: 0,
              },
              {
                display_value: '$1 - $100',
                internal_value: '100',
                visible: true,
                display_order: 1,
              },
              {
                display_value: '$101 - $200',
                internal_value: '200',
                visible: true,
                display_order: 2,
              },
              {
                display_value: '$201 - $500',
                internal_value: '500',
                visible: true,
                display_order: 3,
              },
              {
                display_value: '$501 - $1000',
                internal_value: '1000',
                visible: true,
                display_order: 4,
              },
              {
                display_value: '$1001 - $1500',
                internal_value: '1500',
                visible: true,
                display_order: 5,
              },
              {
                display_value: '$1501 - $2000',
                internal_value: '2000',
                visible: true,
                display_order: 6,
              },
              {
                display_value: '$2001 - $2500',
                internal_value: '2500',
                visible: true,
                display_order: 7,
              },
              {
                display_value: '$2501 - $3000',
                internal_value: '3000',
                visible: true,
                display_order: 8,
              },
              {
                display_value: '$3001 - $3500',
                internal_value: '3500',
                visible: true,
                display_order: 9,
              },
              {
                display_value: '$3501 - $4000',
                internal_value: '4000',
                visible: true,
                display_order: 10,
              },
              {
                display_value: '$4001 - $4500',
                internal_value: '4500',
                visible: true,
                display_order: 11,
              },
              {
                display_value: '$4501 - $5000',
                internal_value: '5000',
                visible: true,
                display_order: 12,
              },
              {
                display_value: '$5001 - $5500',
                internal_value: '5500',
                visible: true,
                display_order: 13,
              },
              {
                display_value: '$5501 - $6000',
                internal_value: '6000',
                visible: true,
                display_order: 14,
              },
              {
                display_value: '$6001 - $6500',
                internal_value: '6500',
                visible: true,
                display_order: 15,
              },
              {
                display_value: '$6501 - $7000',
                internal_value: '7000',
                visible: true,
                display_order: 16,
              },
              {
                display_value: '$7001 - $7500',
                internal_value: '7500',
                visible: true,
                display_order: 17,
              },
              {
                display_value: '$7501 - $8000',
                internal_value: '8000',
                visible: true,
                display_order: 18,
              },
              {
                display_value: '$8001 - $8500',
                internal_value: '8500',
                visible: true,
                display_order: 19,
              },
              {
                display_value: '$8501 - $9000',
                internal_value: '9000',
                visible: true,
                display_order: 20,
              },
              {
                display_value: '$9001 - $9500',
                internal_value: '9500',
                visible: true,
                display_order: 21,
              },
              {
                display_value: '$9501 - $10000',
                internal_value: '10000',
                visible: true,
                display_order: 22,
              },
            ],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_VEH_0_GapCoverage',
            field_type: 'label',
            label: 'Would you like to add Limited Loan/Lease Payoff Coverage for this vehicle?',
            field_value: '',
            group_id: 3,
            index: 0,
            sub_index: null,
            display_order: 146,
            section_display_order: 0,
            help_text: '<p>Loan/Lease Payoff coverage requires Collision coverage. Loan/Lease Payoff coverage protects you if your vehicle sustains a total loss, and will pay you the difference between the actual cash value of the vehicle at the time of a total loss (minus the Comprehensive or Collision deductible, and the salvage value if you or the owner keep the vehicle) and any greater amount you owe under a loan or lease agreement (minus unpaid finance charges, excess mileage charges, and any other charges or expenses associated with the loan or lease). The payoff cannot exceed 25% of the actual cash value of the vehicle at the time of the total loss.</p>',
            sub_text: '',
            placeholder: '',
            visible: false,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 100,
            section: 'Coverage Summary',
            section_type: '',
            sub_section: 'Vehicle Coverages',
            sub_section_type: '',
            sub_index_section: '2006 NISSAN ALTIMA S',
            sub_index_section_type: '',
            rules: [],
            values: [
              {
                display_value: 'Yes',
                internal_value: 'Y',
                visible: true,
                display_order: 1,
              },
              {
                display_value: 'No',
                internal_value: 'N',
                visible: true,
                display_order: 2,
              },
            ],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_VEH_1_Comprehensive',
            field_type: 'label',
            label: 'Comprehensive Deductible',
            field_value: 'CompDed1000',
            group_id: 3,
            index: 0,
            sub_index: null,
            display_order: 141,
            section_display_order: 0,
            help_text: 'Covers vehicle damage, up to vehicle cash value, for non-accident and non-collision claims such as vandalism, damage due to an act of nature, animal collisions and vehicle theft.',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 100,
            section: 'Coverage Summary',
            section_type: '',
            sub_section: 'Vehicle Coverages',
            sub_section_type: '',
            sub_index_section: '2016 BMW 320i',
            sub_index_section_type: '',
            rules: [],
            values: [
              {
                display_value: 'No Coverage (Liability Only)',
                internal_value: 'CompNoCoverage',
                visible: true,
                display_order: 0,
              },
              {
                display_value: '$250 Deductible',
                internal_value: 'CompDed250',
                visible: true,
                display_order: 1,
              },
              {
                display_value: '$500 Deductible',
                internal_value: 'CompDed500',
                visible: true,
                display_order: 2,
              },
              {
                display_value: '$1,000 Deductible',
                internal_value: 'CompDed1000',
                visible: true,
                display_order: 3,
              },
            ],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_VEH_1_Collision',
            field_type: 'label',
            label: 'Collision Deductible',
            field_value: 'CollNoCoverage',
            group_id: 3,
            index: 0,
            sub_index: null,
            display_order: 142,
            section_display_order: 0,
            help_text: 'Coverage applies to damage for policy vehicles, up to vehicle cash value, as a result of when the vehicle is moving and overturns or strikes another object.',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 100,
            section: 'Coverage Summary',
            section_type: '',
            sub_section: 'Vehicle Coverages',
            sub_section_type: '',
            sub_index_section: '2016 BMW 320i',
            sub_index_section_type: '',
            rules: [],
            values: [
              {
                display_value: 'No Coverage (Liability Only)',
                internal_value: 'CollNoCoverage',
                visible: true,
                display_order: 0,
              },
              {
                display_value: '$250 Deductible - Standard',
                internal_value: 'CollDedStd250',
                visible: true,
                display_order: 1,
              },
              {
                display_value: '$500 Deductible - Standard',
                internal_value: 'CollDedStd500',
                visible: true,
                display_order: 2,
              },
              {
                display_value: '$1,000 Deductible - Standard',
                internal_value: 'CollDedStd1000',
                visible: true,
                display_order: 3,
              },
              {
                display_value: '$250 Deductible - Broad',
                internal_value: 'CollDedBrd250',
                visible: true,
                display_order: 4,
              },
              {
                display_value: '$500 Deductible - Broad',
                internal_value: 'CollDedBrd500',
                visible: true,
                display_order: 5,
              },
              {
                display_value: '$1,000 Deductible - Broad',
                internal_value: 'CollDedBrd1000',
                visible: true,
                display_order: 6,
              },
            ],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_VEH_1_Rental',
            field_type: 'label',
            label: 'Rental Reimbursement',
            field_value: 'N',
            group_id: 3,
            index: 0,
            sub_index: null,
            display_order: 143,
            section_display_order: 0,
            help_text: 'Coverage covers rental expenses, up to the selected limits, for when policy vehicles are disabled or in for repairs due to a loss covered by collision or comprehensive coverage.',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 100,
            section: 'Coverage Summary',
            section_type: '',
            sub_section: 'Vehicle Coverages',
            sub_section_type: '',
            sub_index_section: '2016 BMW 320i',
            sub_index_section_type: '',
            rules: [],
            values: [
              {
                display_value: 'Yes',
                internal_value: 'Y',
                visible: true,
                display_order: 0,
              },
              {
                display_value: 'No',
                internal_value: 'N',
                visible: true,
                display_order: 1,
              },
            ],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_VEH_1_Towing',
            field_type: 'label',
            label: 'Towing and Labor',
            field_value: 'Y',
            group_id: 3,
            index: 0,
            sub_index: null,
            display_order: 144,
            section_display_order: 0,
            help_text: 'Coverage reimburses towing and labor costs, up to the selected limit, for disabled policy vehicle(s), regardless of cause. Some carriers refer to “towing” as “roadside assistance”. Few carriers offer roadside assistance similar to AAA, where they actually come and get the customer.',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 100,
            section: 'Coverage Summary',
            section_type: '',
            sub_section: 'Vehicle Coverages',
            sub_section_type: '',
            sub_index_section: '2016 BMW 320i',
            sub_index_section_type: '',
            rules: [],
            values: [
              {
                display_value: 'Yes',
                internal_value: 'Y',
                visible: true,
                display_order: 0,
              },
              {
                display_value: 'No',
                internal_value: 'N',
                visible: true,
                display_order: 1,
              },
            ],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_VEH_1_CustomizationCoverage',
            field_type: 'label',
            label: 'Customized Equipment Coverage',
            field_value: 'None',
            group_id: 3,
            index: 0,
            sub_index: null,
            display_order: 145,
            section_display_order: 0,
            help_text: '',
            sub_text: '',
            placeholder: '',
            visible: true,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 100,
            section: 'Coverage Summary',
            section_type: '',
            sub_section: 'Vehicle Coverages',
            sub_section_type: '',
            sub_index_section: '2016 BMW 320i',
            sub_index_section_type: '',
            rules: [],
            values: [
              {
                display_value: 'No Coverage',
                internal_value: 'None',
                visible: true,
                display_order: 0,
              },
              {
                display_value: '$1 - $100',
                internal_value: '100',
                visible: true,
                display_order: 1,
              },
              {
                display_value: '$101 - $200',
                internal_value: '200',
                visible: true,
                display_order: 2,
              },
              {
                display_value: '$201 - $500',
                internal_value: '500',
                visible: true,
                display_order: 3,
              },
              {
                display_value: '$501 - $1000',
                internal_value: '1000',
                visible: true,
                display_order: 4,
              },
              {
                display_value: '$1001 - $1500',
                internal_value: '1500',
                visible: true,
                display_order: 5,
              },
              {
                display_value: '$1501 - $2000',
                internal_value: '2000',
                visible: true,
                display_order: 6,
              },
              {
                display_value: '$2001 - $2500',
                internal_value: '2500',
                visible: true,
                display_order: 7,
              },
              {
                display_value: '$2501 - $3000',
                internal_value: '3000',
                visible: true,
                display_order: 8,
              },
              {
                display_value: '$3001 - $3500',
                internal_value: '3500',
                visible: true,
                display_order: 9,
              },
              {
                display_value: '$3501 - $4000',
                internal_value: '4000',
                visible: true,
                display_order: 10,
              },
              {
                display_value: '$4001 - $4500',
                internal_value: '4500',
                visible: true,
                display_order: 11,
              },
              {
                display_value: '$4501 - $5000',
                internal_value: '5000',
                visible: true,
                display_order: 12,
              },
              {
                display_value: '$5001 - $5500',
                internal_value: '5500',
                visible: true,
                display_order: 13,
              },
              {
                display_value: '$5501 - $6000',
                internal_value: '6000',
                visible: true,
                display_order: 14,
              },
              {
                display_value: '$6001 - $6500',
                internal_value: '6500',
                visible: true,
                display_order: 15,
              },
              {
                display_value: '$6501 - $7000',
                internal_value: '7000',
                visible: true,
                display_order: 16,
              },
              {
                display_value: '$7001 - $7500',
                internal_value: '7500',
                visible: true,
                display_order: 17,
              },
              {
                display_value: '$7501 - $8000',
                internal_value: '8000',
                visible: true,
                display_order: 18,
              },
              {
                display_value: '$8001 - $8500',
                internal_value: '8500',
                visible: true,
                display_order: 19,
              },
              {
                display_value: '$8501 - $9000',
                internal_value: '9000',
                visible: true,
                display_order: 20,
              },
              {
                display_value: '$9001 - $9500',
                internal_value: '9500',
                visible: true,
                display_order: 21,
              },
              {
                display_value: '$9501 - $10000',
                internal_value: '10000',
                visible: true,
                display_order: 22,
              },
            ],
            has_error: false,
            error: null,
          },
          {
            field_name: 'QTE_VEH_1_GapCoverage',
            field_type: 'label',
            label: 'Would you like to add Limited Loan/Lease Payoff Coverage for this vehicle?',
            field_value: '',
            group_id: 3,
            index: 0,
            sub_index: null,
            display_order: 146,
            section_display_order: 0,
            help_text: '<p>Loan/Lease Payoff coverage requires Collision coverage. Loan/Lease Payoff coverage protects you if your vehicle sustains a total loss, and will pay you the difference between the actual cash value of the vehicle at the time of a total loss (minus the Comprehensive or Collision deductible, and the salvage value if you or the owner keep the vehicle) and any greater amount you owe under a loan or lease agreement (minus unpaid finance charges, excess mileage charges, and any other charges or expenses associated with the loan or lease). The payoff cannot exceed 25% of the actual cash value of the vehicle at the time of the total loss.</p>',
            sub_text: '',
            placeholder: '',
            visible: false,
            is_quote_summary_field: false,
            is_enabled: true,
            is_required: false,
            script: '',
            max_length: 100,
            section: 'Coverage Summary',
            section_type: '',
            sub_section: 'Vehicle Coverages',
            sub_section_type: '',
            sub_index_section: '2016 BMW 320i',
            sub_index_section_type: '',
            rules: [],
            values: [
              {
                display_value: 'Yes',
                internal_value: 'Y',
                visible: true,
                display_order: 1,
              },
              {
                display_value: 'No',
                internal_value: 'N',
                visible: true,
                display_order: 2,
              },
            ],
            has_error: false,
            error: null,
          },
          {
            field_name: 'Disclosure1',
            field_type: 'label',
            label: null,
            field_value: 'You have opted to electronically sign all Progressive policy-related documents. Within the next few minutes you will receive an email from Progressive that contains a temporary user ID and password. As soon as you receive this email, log into www.progressive.com/agent/ and follow the onscreen instructions to complete your purchase of insurance. Please be aware that you may be required to mail or fax additional documents to Progressive as part of this process.  Your insurance premium is based on the information you provided in the application. If Progressive does not receive the items requested, your insurance premium may change.',
            group_id: 0,
            index: null,
            sub_index: null,
            display_order: 0,
            section_display_order: 0,
            help_text: null,
            sub_text: null,
            placeholder: null,
            visible: true,
            is_quote_summary_field: false,
            is_enabled: false,
            is_required: false,
            script: null,
            max_length: null,
            section: 'Next Steps',
            section_type: null,
            sub_section: null,
            sub_section_type: null,
            sub_index_section: null,
            sub_index_section_type: null,
            rules: [],
            values: [],
            has_error: false,
            error: null,
          },
          {
            field_name: 'Disclosure2',
            field_type: 'label',
            label: null,
            field_value: 'Thanks for giving Snapshot a try! When your device arrives in the mail—it takes a week or so—simply plug it into your car, and then at renewal you’ll receive a personalized rate based on how you drive.  Remember, you need to plug it in to keep your first term discount.',
            group_id: 0,
            index: null,
            sub_index: null,
            display_order: 0,
            section_display_order: 0,
            help_text: null,
            sub_text: null,
            placeholder: null,
            visible: true,
            is_quote_summary_field: false,
            is_enabled: false,
            is_required: false,
            script: null,
            max_length: null,
            section: 'Next Steps',
            section_type: null,
            sub_section: null,
            sub_section_type: null,
            sub_index_section: null,
            sub_index_section_type: null,
            rules: [],
            values: [],
            has_error: false,
            error: null,
          },
        ],
        payment_plan_fields: [],
        carrier_final_rate_section: {
          logo_path: 'http://dev.insurance.com/insurance/media/carrier/ucp/prog_ucp_logo_small.gif',
          premium_amount: null,
          policy_term: null,
          original_premium_amount: null,
          original_policy_term: null,
          blurb: '<p>Customer Service & Claims <b>1-855-457-7359</b></p>',
          premium_adjustment_reason: null,
          section: 'Carrier Logo With Customer Service Contact Number',
        },
        carrier_payment_information_section: [],
        carrier_driver_incidents_section: [],
        blurbs: [{
          content: "Content here.",
          location: "formtop",
          visible: true,
        }, {
          content: "All required questions must be completed before carrier results are generated. Please complete any incomplete pages before running carrier results.",
          location: "formbottom",
          visible: true,
        }],
        bill_plan: {
          bill_plan_installments: [
            {
              installment_name: 'Today\'s Payment',
              installment_date: '02/12/2019',
              amount: '304.79',
            },
            {
              installment_name: 'Installment 1',
              installment_date: '03/31/2019',
              amount: '305.83',
            },
            {
              installment_name: 'Installment 2',
              installment_date: '04/30/2019',
              amount: '305.83',
            },
            {
              installment_name: 'Installment 3',
              installment_date: '05/31/2019',
              amount: '305.83',
            },
            {
              installment_name: 'Installment 4',
              installment_date: '06/30/2019',
              amount: '305.83',
            },
            {
              installment_name: 'Installment 5',
              installment_date: '07/31/2019',
              amount: '305.83',
            },
            {
              installment_name: 'Installment 6',
              installment_date: '08/31/2019',
              amount: '305.83',
            },
            {
              installment_name: 'Installment 7',
              installment_date: '09/30/2019',
              amount: '305.83',
            },
            {
              installment_name: 'Installment 8',
              installment_date: '10/31/2019',
              amount: '305.83',
            },
            {
              installment_name: 'Installment 9',
              installment_date: '11/30/2019',
              amount: '305.83',
            },
            {
              installment_name: 'Installment 10',
              installment_date: '12/31/2019',
              amount: '305.74',
            },
          ],
          script: '',
          logo_url: 'http://dev.insurance.com/insurance/media/carrier/ucp/prog_ucp_logo_small.gif',
          bill_plan_id: 'ElevenPay_EFT_9.09',
          bill_plan_name: '11 Payment - Installment Breakdown',
          bill_plan_total: '3363',
        },
        Error: null,
        quote_summary: {
        "quote_status": "BindError",
        "is_created_in_qrp_for_epic": false,
        "is_exportable_to_epic": false,
        "quote_summary_sections": [
          {
            label: 'Named Insured',
            content: [
              {
                fields: [
                  {
                    label: 'Name',
                    field_value: 'Raul Sin',
                  },
                  {
                    label: 'Address',
                    field_value: '5723 Cabot St Detroit, MI 48210',
                  },
                  {
                    label: 'Email',
                    field_value: 'qrpmi@email.com',
                  },
                  {
                    label: 'Phone',
                    field_value: '6505787700',
                  },
                ],
              },
            ],
          },
          {
            label: 'Vehicle(s)',
            content: [
              {
                fields: [
                  {
                    label: 'Vehicle',
                    field_value: '2006 NISSAN ALTIMA S',
                  },
                  {
                    label: 'VIN',
                    field_value: '1N4AL11EX6N320276',
                  },
                  {
                    label: 'Ownership',
                    field_value: 'Owned',
                  },
                  {
                    label: 'Annual Mileage',
                    field_value: '8000',
                  },
                ],
              },
            ],
          },
        ],
        }
      }
    },
    footerNote() {
      let footerNote = null;

      if (this.pageData.blurbs) {
        this.pageData.blurbs.forEach((blurb) => {
          if (blurb.visible && blurb.location === 'formbottom' && blurb.content) { // TODO: Use config value
            footerNote = blurb.content;
          }
        });
      }

      return footerNote;
    },
    /**
     * Creates a tree from the data. The tree has "groups" as its nodes, and "fields" as the
     * leaves of those nodes.
     *
     * @param {Object} field_name Unique name of field
     * @param {Array} fields List of fields
     * @param {Object} field.field_name Unique name of field
     * @param {Object} field.field_type `FormBlock.vue` currently expecting value of `display`
     * @param {Object} field.group_id Int of the group the field belongs
     * @param {Object} field.group_parent Currently not in use, but will attach nodes to other nodes
     * @param {Object} field.section Name of group, which will be displayed above the 1st child of the group
     */
    createTree() {
      const dataFields = this.pageData.fields;
      if (dataFields !== null) {
        for (let j = 0; j < dataFields.length; j += 1) { // Iterator over all the fields
          if (typeof this.dataTree[0] === 'undefined') {
            this.dataTree[0] = []; // Create node if it does not exist
          }

          if (!this.dataTree[0]) {
            this.dataTree[0] = [];
          }

          let section = (dataFields[j].section ? dataFields[j].section : 'untitled');
          let sub_section = (dataFields[j].sub_section ? dataFields[j].sub_section : 'untitled');
          let sub_sub_section = (dataFields[j].sub_index_section ? dataFields[j].sub_index_section : 'untitled');

          if (!this.dataTree[0][section]) {
            this.dataTree[0][section] = [];
          }

          if (!this.dataTree[0][section][sub_section]) {
            this.dataTree[0][section][sub_section] = [];
          }

          if (!this.dataTree[0][section][sub_section][sub_sub_section]) {
            this.dataTree[0][section][sub_section][sub_sub_section] = [];
          }

          this.dataTree[0][section][sub_section][sub_sub_section].push(dataFields[j]);
        }
      } else {        
        this.dataTree[0] = [];
      }
      console.log('this.dataTree', this.dataTree);
    },
  },
  created() {     
    let carrierCode = sessionStorage.getItem('autoPageName').substring(0, 4);//TODO: check if its working for each carrier

    let AUQuoteId = JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId;
    let cuurentNav  = `/pages/${carrierCode}Confirmation/${AUQuoteId}`;
    const requestParam = {
      url: cuurentNav,//this.$store.getters.getNavLink,
      // url: `/pages/nwidconfirmation/${AUQuoteId}`,
      // url: `/pages/progconfirmation/${AUQuoteId}`,
    };
    const startTimeVal = (new Date()).getTime();
    fetchData.getPageData(requestParam).then((response) => {
      // log API response time through application into GA tool
      common.gapRecordAnalyticsGeneric(startTimeVal, 'API', response.data.page_name);
      this.pageData = response.data;
      this.$root.$emit('pageDataUpdate', this.pageData);

      this.rc2Logo();
      
      if (this.pageData.Error) {
        let carrier_name = sessionStorage.getItem('selectedCarrierAuto') && sessionStorage.getItem('selectedCarrierAuto')!=="null" ? JSON.parse(sessionStorage.getItem('selectedCarrierAuto')).carrier_name : '';
        this.pageTitle = `Unfortunately, ${carrier_name} is unable to provide coverage for this customer.`;
        this.$store.commit('setAutoBindStatus', this.pageData.Error);
        this.isBindError = true;
        this.logoPathSvg = sessionStorage.getItem('selectedCarrierAuto') && sessionStorage.getItem('selectedCarrierAuto')!=="null" ? JSON.parse(sessionStorage.getItem('selectedCarrierAuto')).logoPathSvg : '';
      } else {
        this.pageTitle = this.pageData.carrier_final_rate_section.section;
        let response = {
          'Status' : 'Success',
        };
        this.$store.commit('setAutoBindStatus', response);
        sessionStorage.setItem('autobound', true);
      }
      this.createTree();
      common.gapRecordAnalytics(response.data.page_name);
    });

    // TODO: Remove after development is complete. Only used for mock data
    // this.pageData = this.fallbackData();
    // this.pageTitle = this.pageData.carrier_final_rate_section.section;
    // this.createTree();
  },
  mounted() {
  },
};
</script>

<style scoped lang="scss">
.carrier-logo-property {
  min-height: 80px;
  &.min-height {
    min-height: 129px;
  }
}
.next-step-row {
  hyphens: auto !important;
}
.policy-type {
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
}

.text-gray {
  color: #666666 !important;
}

.bg-gray {
  background-color: #666666 !important;
}

h1.title-banner::before {
  font-family: "Font Awesome 5 Pro", "Font Awesome 5 Free";
  font-weight: 600;
  content: "\f058";
  margin-right: 0.25rem;
}
.product-section-heading {
  background-color: $var-qs-dark-blue;  
  padding: 14px 0;

  &.error {
    background-color: #BB0000;
    h1.title-banner::before {
      content: "\f06a";
    }
  }
}

/**BREAKDOWN SECTION**/
.breakdown-item {
  border-bottom: 1px solid #DEE2E6;
}

/***header/footer information blurb***/
@media all and (max-width: 992px) {
  .alert.alert-primary {
    width: 100% !important;
  }
}
@media all and (max-width: 1279px) {
  .carrier-logo-property.min-height {
    min-height: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/interview/shared/AutoConfirmation.vue?44d3779f